var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-list"},_vm._l((_vm.menus),function(menu,index){return _c('li',{key:index},[_c('menu-item',{class:{ 'is-active': _vm.isActive(menu) },attrs:{"menu":menu}}),_vm._v(" "),(menu.children.length)?_c('menus',{attrs:{"menus":menu.children,"is-active":_vm.isActive,"collapsed":!menu.expanded},on:{"shrink":_vm.shrink,"extend":_vm.extend}}):_vm._e()],1)}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ac2fec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/core/structure/menu/Menus.vue
// module id = teG1
// module chunks = 66